<template>
    <div id="app">
        <!-- <div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
</div> -->
    <v-app>
        <v-content>
        <router-view />
        </v-content>
    </v-app>
    </div>
</template>

<script>
export default {
    name:'App'
}
</script>

<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: rgba(15, 17, 32, 1);
}

#app a {
    cursor: pointer;
}

#nav {
    padding: 30px;
}

#nav a {
    font-weight: bold;
    color: rgba(15, 17, 32, 1);
}

#nav a.router-link-exact-active {
    color: #42b983;
}
</style>